import { createStackNavigator } from '@react-navigation/stack'
import { useTheme } from '@rneui/themed'
import { t } from 'app/i18l'
import { ActivateScreen } from 'onboarding/screens/activate'
import { AuthScreen } from 'onboarding/screens/auth'
import OnboardScreen from 'onboarding/screens/onboard'
import { VerifyScreen } from 'onboarding/screens/verify'
import { WelcomeScreen } from 'onboarding/screens/welcome'
import React from 'react'
import { WebScreen } from 'web/screen'
import { OnboardingRoutes } from './types'

const Stack = createStackNavigator<OnboardingRoutes>()

export function OnboardingStack() {
  const { theme } = useTheme()

  return (
    <Stack.Navigator
      screenOptions={() => ({
        cardStyle: { backgroundColor: theme.colors?.white },
        headerTintColor: theme.colors.grey0,
        headerBackTruncatedTitle: t('back'),
        headerBackAllowFontScaling: false,
        headerTitleAllowFontScaling: false,
        headerBackButtonDisplayMode: 'minimal',
        headerTitleStyle: {
          width: '100%',
        },
      })}
    >
      <Stack.Screen
        component={WelcomeScreen}
        name="welcome"
        options={() => ({
          headerShown: false,
        })}
      />
      <Stack.Screen
        component={AuthScreen}
        name="auth"
        options={() => ({
          headerShown: false,
        })}
      />
      <Stack.Screen
        component={VerifyScreen}
        name="verify"
        options={() => ({
          title: t('welcomeToNext'),
        })}
      />
      <Stack.Screen
        component={ActivateScreen}
        name="activate"
        options={() => ({
          title: t('activate'),
        })}
      />
      <Stack.Screen
        component={OnboardScreen}
        name="onboard"
        options={() => ({
          title: t('onboard'),
        })}
      />
      <Stack.Screen
        component={WebScreen}
        name="web"
        options={() => ({
          headerLeft: () => null,
        })}
      />
    </Stack.Navigator>
  )
}
